/**
 * @Description
 */
export default {
  meta: {
    title: '付款记录'
  }
};
